// extracted by mini-css-extract-plugin
export default {"pastReviewsContainer":"PastReviews_pastReviewsContainer__eWn1Q","reviewsContainer":"PastReviews_reviewsContainer__uVwcc"};